import * as React from "react";
const SvgService20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M3.837.954a7.5 7.5 0 0 1 10.821 8.79l4.3 4.299a3.475 3.475 0 0 1-4.915 4.914l-4.299-4.299A7.5 7.5 0 0 1 .954 3.837L1.6 2.685l4.9 4.9L7.586 6.5l-4.9-4.9 1.15-.646ZM6.095 2.18l4.32 4.319L6.5 10.414 2.18 6.095a5.5 5.5 0 0 0 7.435 6.483l.62-.258 5.222 5.223a1.475 1.475 0 1 0 2.086-2.086l-5.223-5.222.258-.619a5.5 5.5 0 0 0-6.483-7.435Z",
      clipRule: "evenodd"
    })
  );
export default SvgService20Px;
